import { map, Observable, of } from 'rxjs';
import { AuthService } from '@nimmsta/ng-commons-lib/auth';
import { CustomAction } from '@nimmsta/ng-commons-lib/data-table';
import { User, UserRole } from '@nimmsta/ng-commons-lib/models';

export class DeleteUserAction extends CustomAction<User> {
  private authService: AuthService;

  constructor(text: string, authService: AuthService) {
    super(text, false, true);
    this.authService = authService;
  }

  override isEnabled(item: User): Observable<boolean> {
    if (item.isSecondaryOrgMember) {
      return of(false);
    }
    return this.authService.getCurrentUser().pipe(
      map((user) => user.role === UserRole.ADMIN || item.role !== UserRole.ADMIN),
    );
  }
}
